/**
 * Price range chips. The chips behave as a single-select group that can be
 * emptied, and write the chosen range onto the hidden min/max inputs the form
 * submits — the chips themselves carry no name.
 */
class PriceRangeFilter extends HTMLElement {
  // Runs before the form's own input listener, so the hidden inputs are
  // current by the time the form is serialized.
  handleInput = (e) => {
    const chip = e.target.closest("[data-price-range]");
    if (!chip) return;

    if (chip.checked) {
      this.chips.forEach((el) => {
        if (el !== chip) el.checked = false;
      });
    }

    this.sync();
  };

  connectedCallback() {
    this.addEventListener("input", this.handleInput);
  }

  disconnectedCallback() {
    this.removeEventListener("input", this.handleInput);
  }

  get chips() {
    return [...this.querySelectorAll("[data-price-range]")];
  }

  sync() {
    const chip = this.chips.find((el) => el.checked);

    this.setInputValue(this.querySelector("[data-min]"), chip?.dataset.min);
    this.setInputValue(this.querySelector("[data-max]"), chip?.dataset.max);
  }

  setInputValue(input, value) {
    if (!input) return;

    if (value === undefined || value === "") {
      input.removeAttribute("name");
      input.value = "";
      return;
    }

    input.setAttribute("name", input.dataset.name);
    input.value = value;
  }
}

if (!customElements.get("price-range-filter")) {
  customElements.define("price-range-filter", PriceRangeFilter);
}
